export default __webpack_public_path__ + "static/media/mobilephones_Image.a20ecab0.png";